"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpecialPageContent = SpecialPageContent;

var _react = _interopRequireDefault(require("react"));

function SpecialPageContent(props) {
  return _react["default"].createElement("div", {
    style: {
      fontSize: '28px',
      color: '#6b686f',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh'
    }
  }, props.children);
}